import React, { useMemo, useRef, useState } from 'react'
import { ColDef } from 'ag-grid-community'
import { HStack } from '@musinsa/mwms-ds'
import GridTable from '@/components/table/GridTable'
import { OutboundSummaryItem } from '@/services/outbound/outboundSearch/types'
import { GRID_SIZE } from '@/utils/grid/grid'
import Button from '@/components/content/Button'
import { AgGridReact } from 'ag-grid-react'

interface OutboundSearchBatchTableProps {
  items: OutboundSummaryItem[]
  pageInfo?: PageInfoType
  isLoading?: boolean
  currentPage?: number
  onChangePage?: (page: number) => void
  onDetailSearch: (item: OutboundSummaryItem) => Promise<void>
  onCancelClick: (item: OutboundSummaryItem) => void
}
export const OutboundSearchBatchTable = ({
  items,
  pageInfo,
  isLoading,
  currentPage,
  onChangePage,
  onDetailSearch,
  onCancelClick,
}: OutboundSearchBatchTableProps) => {
  const $grid = useRef<AgGridReact>(null)
  const [isCancelButtonDisabled, setIsCancelButtonDisabled] = useState(true)
  
  const columnDefs = useMemo<ColDef<OutboundSummaryItem>[]>(() => {
    return [
      { field: 'cutStatus', headerName: '출고지시상태', width: 120 },
      { field: 'cutDate', headerName: '출고등록일', cellDataType: 'dateNday', width: 120 },
      { field: 'cutOffNo', headerName: '차수명', width: 250 },
      { field: 'orderType', headerName: '주문유형', width: 100 },
      { field: 'transportType', headerName: '배송유형', width: 100 },
      { field: 'orderCount', headerName: '주문건수', width: 100 },
      { field: 'orderQuantity', headerName: '주문수량', width: 90 },
      { field: 'allocatedQuantity', headerName: '할당수량', width: 90 },
      { field: 'cutOffDateTime', headerName: '컷오프 시간', cellDataType: 'datetime' },
    ]
  }, [])

  
  const handleRowSelected = () => {
    const selectedRows = $grid.current?.api.getSelectedRows()
    setIsCancelButtonDisabled(!selectedRows || selectedRows.length === 0)
  }
  
  const handleCancelClick = () => {
    const selectedRows = $grid.current?.api.getSelectedRows()
    if (selectedRows && selectedRows.length > 0) {
      onCancelClick(selectedRows[0])
    }
  }
  
  
  return (
    <HStack full gap={16}>
      <GridTable<OutboundSummaryItem>
        ref={$grid}
        rowSelectable
        useColumnNo
        title={
          <HStack gap={16}>
            <span>차수 목록</span>
            <Button
              fit
              size="sm"
              kind="secondary"
              type="button"
              disabled={isCancelButtonDisabled}
              onClick={handleCancelClick}
            >
              출고취소
            </Button>
          </HStack>
        }
        rowSelection="single"
        isRowSelectable={(params) => params.data?.cutType === 'MANUAL'}
        isLoading={isLoading}
        rowData={items}
        countPerPage={GRID_SIZE.MEDIUM}
        currentPage={currentPage}
        totalPages={pageInfo?.totalPages}
        totalCount={pageInfo?.totalCount || 0}
        onChangePage={onChangePage}
        onRowSelected={handleRowSelected}
        onRowDoubleClicked={(event) => event.data && onDetailSearch(event.data)}
        columnDefs={columnDefs}
        gridKey="GI24_HEAD"
        legacyStorageKey="outbound-search-batch-table"
      />
    </HStack>
  )
}
